/**
 * Ace highlight rules for the pyst query language, ported from the token classes in
 * pyst-vscode's `pyst-liquid.tmLanguage.json` so the editor here colours the same
 * things the VS Code extension does. Takes the `ace` object rather than importing it
 * so the same definition can be loaded outside the Angular bundle.
 */
export const PYST_ACE_MODE = 'ace/mode/pyst';

let registered = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerPystAceMode(ace: any): void {
    if (registered) {
        return;
    }
    registered = true;

    // Captured before the define callback: TypeScript compiles `PYST_ACE_MODE` to
    // `exports.PYST_ACE_MODE`, and the callback's own exports parameter would shadow
    // that and read undefined — leaving the mode without the $id Ace keys on.
    const modeId = PYST_ACE_MODE;

    ace.define(
        modeId,
        ['require', 'exports', 'module', 'ace/lib/oop', 'ace/mode/text', 'ace/mode/text_highlight_rules'],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acequire: any, moduleExports: any) => {
            const oop = acequire('ace/lib/oop');
            const TextMode = acequire('ace/mode/text').Mode;
            const TextHighlightRules = acequire('ace/mode/text_highlight_rules').TextHighlightRules;

            const PystHighlightRules = function (this: { $rules: unknown }) {
                this.$rules = {
                    start: [
                        { token: 'string', regex: /'(?:[^']|'')*'/ },
                        { token: 'string', regex: /"(?:[^"\\]|\\.)*"/ },
                        // OData system options before generic $params, so $apply is
                        // coloured as structure rather than as a kwarg.
                        { token: 'variable.parameter.odata', regex: /\$(?:filter|select|apply|expand|orderby|top|skip|count)\b/ },
                        { token: 'variable.parameter', regex: /\$[A-Za-z_][A-Za-z0-9_]*/ },
                        { token: 'entity.name.function.macro', regex: /~[A-Za-z_][A-Za-z0-9_]*/ },
                        { token: 'support.function.py', regex: /\bpy_[A-Za-z0-9_]+(?=\()/ },
                        { token: 'keyword.operator', regex: /\b(?:eq|ne|gt|ge|lt|le|and|or|not|add|sub|mul|div|mod|in|as|vs|true|false|null)\b/ },
                        { token: 'constant.numeric', regex: /\b\d+(?:\.\d+)?\b/ },
                        { token: 'support.function', regex: /\b[a-z][A-Za-z0-9_]*(?=\()/ },
                        { token: 'entity.name.class', regex: /\b[A-Z][A-Za-z0-9_]*\b/ },
                        { token: 'keyword.operator.pipe', regex: /\// },
                        { token: 'paren.lparen', regex: /[([]/ },
                        { token: 'paren.rparen', regex: /[)\]]/ },
                        { token: 'text', regex: /\s+/ },
                    ],
                };
            };
            oop.inherits(PystHighlightRules, TextHighlightRules);

            const Mode = function (this: { HighlightRules: unknown; $id: string }) {
                this.HighlightRules = PystHighlightRules;
                this.$id = modeId;
            };
            oop.inherits(Mode, TextMode);

            moduleExports.Mode = Mode;
            moduleExports.PystHighlightRules = PystHighlightRules;
        },
    );
    // Force the module to evaluate now so setMode() can find it synchronously.
    ace.require([modeId], () => undefined);
}
